(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      document.body.classList.toggle('nav-open', open);
      toggle.setAttribute('aria-expanded', open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) toggle.click();
    });
  }

  var root = document.querySelector('[data-product]');
  if (root) {
    var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    var mediaMap = JSON.parse(root.querySelector('[data-media-map]').textContent);
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form.querySelector('[name=id]');
    var priceEl = root.querySelector('[data-price]');
    var btn = form.querySelector('[data-add]');
    var currency = root.getAttribute('data-currency');
    var fmt = function (c) {
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2); }
    };
    var showMedia = function (id) {
      var thumbs = root.querySelectorAll('[data-thumb]');
      var stage = root.querySelector('[data-stage] img');
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-media-id') == id;
        t.classList.toggle('is-active', on);
        if (on) { stage.src = t.getAttribute('data-large'); stage.alt = t.getAttribute('data-alt') || ''; }
      });
    };
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); });
    });
    var update = function () {
      var sel = [];
      root.querySelectorAll('.opt').forEach(function (fs) {
        var c = fs.querySelector('input:checked'); if (c) sel.push(c.value);
      });
      var v = variants.filter(function (x) { return x.options.join('|') === sel.join('|'); })[0];
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.innerHTML = fmt(v.price) + (v.compare_at_price > v.price ? ' <s>' + fmt(v.compare_at_price) + '</s>' : '');
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (mediaMap[v.id]) showMedia(mediaMap[v.id]);
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u);
    };
    root.querySelectorAll('.opt input').forEach(function (i) { i.addEventListener('change', update); });
    var q = root.querySelector('[data-qty]');
    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
        q.value = n;
      });
    });
  }

  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  });
})();
